
    import { attachCanvas } from './ActiveFrame.js';

    (async () => {
      if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
      }

      window.scrollTo(0, 0);

      const canvas = document.getElementById('canvas');
      const frameLabel = document.getElementById('frame');

      function checkSupport(codec) {
        return VideoDecoder.isConfigSupported({
          codec: codec === 'h264' ? 'avc1.42c033' : 'hvc1.1.6.L120.90',
        });
      }

      function showUnsupported() {
        document.getElementById('loading').innerHTML = 'Unsupported';
      }

      let portrait = window.innerWidth < window.innerHeight;
      let codec = 'h265';

      if (!('VideoDecoder' in window)) {
        return showUnsupported();
      }

      const [supportH265, supportH264] = await Promise.all([checkSupport('h265'), checkSupport('h264')]);

      if (!supportH265.supported && !supportH264.supported) {
        return showUnsupported();
      }

      if (supportH265.supported) {
        codec = 'h265';
      } else {
        codec = 'h264';
      }

      console.log(supportH265, supportH264);

      let hardwareAcceleration = 'prefer-hardware';

      if (/\bAndroid\b/i.test(navigator.userAgent)) {
        // The situation on android is very segmented
        // Certain hardware accelerated decoders are not efficient with random access
        // Need to find a better way to detect and degrade
        // file = 'assets/meridian_1k_h264.af';
        codec = 'h264';
        hardwareAcceleration = 'prefer-software';
      }

      let file = `assets/${portrait ? 'p_' : ''}meridian_${codec}.af`;

      const player = attachCanvas(canvas, file, {
        hardwareAcceleration,
        fit: 'cover',
        onDraw: () => {
          frameLabel.innerHTML = `Frame: ${player.getCurrentFrame()}`;
        },
      });

      await player.loading;
      document.getElementById('loading').style.display = 'none';
      player.setFrame(0);

      const totalFrames = player.getManifest().totalFrames;

      window.addEventListener('scroll', function() {
        const scrollPosition = window.scrollY;
        const totalHeight = document.body.scrollHeight;
        const viewportHeight = window.innerHeight;
        const progress = scrollPosition / (totalHeight - viewportHeight);
        const frame = Math.round(progress * (totalFrames - 1));
        player.setFrame(frame);
      });
    })();
  